module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/074e6f8245cb1506deafdeac71991a5d.gif";